import type { Definition, Word } from '../types/word.types';

const mockDefinitionTemplates = [
  {
    partOfSpeech: 'noun',
    meanings: ['a thing', 'an object', 'a concept', 'a person or place']
  },
  {
    partOfSpeech: 'verb',
    meanings: ['to do something', 'to perform an action', 'to execute', 'to make or create']
  },
  {
    partOfSpeech: 'adjective',
    meanings: ['describing a quality', 'having a characteristic', 'being in a state']
  },
  {
    partOfSpeech: 'adverb',
    meanings: ['in a manner', 'to a degree', 'at a time or place']
  },
];

export const generateMockDefinition = (word: string): Definition[] => {
  const randomTemplate = mockDefinitionTemplates[
    Math.floor(Math.random() * mockDefinitionTemplates.length)
  ];

  const randomMeaning = randomTemplate.meanings[
    Math.floor(Math.random() * randomTemplate.meanings.length)
  ];

  return [
    {
      partOfSpeech: randomTemplate.partOfSpeech,
      meaning: `[Mock] ${randomMeaning} related to "${word}"`,
      example: `Example: This is how you use "${word}" in a sentence.`,
    },
  ];
};

export const generateId = (): string => {
  return `word-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
};

// Mock data for Fill-in-the-Blank demo
export const fillInTheBlankDemoData = {
  paragraph: 'The scientist conducted an __1__ to test her __2__ about climate change. The results were __3__ and supported her initial __4__.',
  answers: ['experiment', 'hypothesis', 'conclusive', 'theory'],
  words: [
    {
      id: 'demo-word-1',
      word: 'experiment',
      definitions: [
        {
          partOfSpeech: 'noun',
          meaning: 'A scientific procedure undertaken to make a discovery, test a hypothesis, or demonstrate a known fact',
          example: 'The chemistry experiment helped us understand the reaction between different elements.',
          synonyms: ['test', 'trial', 'procedure'],
          antonyms: [],
          definitions: [
            {
              definition: 'A scientific procedure undertaken to make a discovery, test a hypothesis, or demonstrate a known fact',
              example: 'The chemistry experiment helped us understand the reaction between different elements.',
              synonyms: ['test', 'trial'],
              antonyms: []
            }
          ]
        }
      ],
      addedAt: new Date(),
      rating: 3,
    },
    {
      id: 'demo-word-2',
      word: 'hypothesis',
      definitions: [
        {
          partOfSpeech: 'noun',
          meaning: 'A proposed explanation made on the basis of limited evidence as a starting point for further investigation',
          example: 'The researchers formed a hypothesis that increased temperature would accelerate the chemical reaction.',
          synonyms: ['theory', 'supposition', 'assumption'],
          antonyms: [],
          definitions: [
            {
              definition: 'A proposed explanation made on the basis of limited evidence as a starting point for further investigation',
              example: 'The researchers formed a hypothesis that increased temperature would accelerate the chemical reaction.',
              synonyms: ['theory', 'supposition'],
              antonyms: []
            }
          ]
        }
      ],
      addedAt: new Date(),
      rating: 3,
    },
    {
      id: 'demo-word-3',
      word: 'conclusive',
      definitions: [
        {
          partOfSpeech: 'adjective',
          meaning: 'Serving to prove or settle something conclusively; final',
          example: 'The conclusive evidence presented by the prosecution convinced the jury.',
          synonyms: ['decisive', 'definitive', 'final'],
          antonyms: ['inconclusive', 'uncertain'],
          definitions: [
            {
              definition: 'Serving to prove or settle something conclusively; final',
              example: 'The conclusive evidence presented by the prosecution convinced the jury.',
              synonyms: ['decisive', 'definitive'],
              antonyms: ['inconclusive']
            }
          ]
        }
      ],
      addedAt: new Date(),
      rating: 3,
    },
    {
      id: 'demo-word-4',
      word: 'theory',
      definitions: [
        {
          partOfSpeech: 'noun',
          meaning: 'A system of ideas intended to explain something, especially one based on general principles independent of the thing to be explained',
          example: 'Einstein\'s theory of relativity revolutionized our understanding of physics.',
          synonyms: ['hypothesis', 'principle', 'idea'],
          antonyms: [],
          definitions: [
            {
              definition: 'A system of ideas intended to explain something, especially one based on general principles independent of the thing to be explained',
              example: 'Einstein\'s theory of relativity revolutionized our understanding of physics.',
              synonyms: ['hypothesis', 'principle'],
              antonyms: []
            }
          ]
        }
      ],
      addedAt: new Date(),
      rating: 3,
    }
  ] as Word[]
};
